<template>
    <div class="componente-search-by-model-make-planning">
        <v-container fluid class="container--fluid--override">
            <v-row align="center" :class="dialog ? 'ml-1 mr-1' : ''">
                <v-col class="d-flex" cols="12" :sm="dialog ? 12 : 4">
                    <v-text-field
                        v-if="!readonly"
                        :label="
                            $t(
                                'planning.form-planning-event.form-search-by-model-brand.plate-label'
                            )
                        "
                        v-model="manualPlateValue"
                        filled
                    ></v-text-field>
                    <v-text-field
                        v-else
                        :label="
                            $t(
                                'planning.form-planning-event.form-vehicle-manual-search.plate-label'
                            )
                        "
                        v-model="manualPlate"
                        filled
                        readonly
                    ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" :sm="dialog ? 12 : 4">
                    <v-combobox
                        v-if="!readonly"
                        v-model="comboBoxmakeValue"
                        :items="comboBoxes.make.items"
                        :label="
                            $t(
                                'planning.form-planning-event.form-search-by-model-brand.select-brand'
                            )
                        "
                        filled
                        :disabled="comboBoxes.make.disable"
                        :loading="comboBoxes.make.loading"
                    ></v-combobox>
                    <v-text-field
                        v-else
                        v-model="make"
                        :label="
                            $t(
                                'planning.form-planning-event.form-vehicle-manual-search.select-brand'
                            )
                        "
                        filled
                        readonly
                    ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" :sm="dialog ? 12 : 4">
                    <v-combobox
                        v-if="!readonly"
                        v-model="comboBoxmodelValue"
                        :items="comboBoxes.model.items"
                        :label="
                            $t(
                                'planning.form-planning-event.form-search-by-model-brand.select-model'
                            )
                        "
                        filled
                        :disabled="comboBoxes.model.disable"
                        :loading="comboBoxes.model.loading"
                    ></v-combobox>
                    <v-text-field
                        v-else
                        v-model="model"
                        :label="
                            $t(
                                'planning.form-planning-event.form-vehicle-manual-search.select-model'
                            )
                        "
                        filled
                        readonly
                    ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" :sm="dialog ? 12 : 4">
                    <v-combobox
                        v-if="!readonly"
                        v-model="comboBoxbodyworkValue"
                        :items="comboBoxes.bodywork.items"
                        :label="
                            $t(
                                'planning.form-planning-event.form-search-by-model-brand.select-body-group'
                            )
                        "
                        filled
                        :disabled="comboBoxes.bodywork.disable"
                        :loading="comboBoxes.bodywork.loading"
                    ></v-combobox>
                    <v-text-field
                        v-else
                        v-model="bodyGroup"
                        :label="
                            $t(
                                'planning.form-planning-event.form-vehicle-manual-search.select-body-group'
                            )
                        "
                        filled
                        readonly
                    ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" :sm="dialog ? 12 : 4">
                    <v-combobox
                        v-if="!readonly"
                        v-model="comboBoxfuelValue"
                        :items="comboBoxes.fuel.items"
                        :label="
                            $t(
                                'planning.form-planning-event.form-search-by-model-brand.select-fuel-type'
                            )
                        "
                        filled
                        :disabled="comboBoxes.fuel.disable"
                        :loading="comboBoxes.fuel.loading"
                    ></v-combobox>
                    <v-text-field
                        v-else
                        v-model="fuelType"
                        :label="
                            $t(
                                'planning.form-planning-event.form-vehicle-manual-search.select-fuel-type'
                            )
                        "
                        filled
                        readonly
                    ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" :sm="dialog ? 12 : 4">
                    <v-combobox
                        v-if="!readonly"
                        v-model="comboBoxversionValue"
                        :items="comboBoxes.version.items"
                        :label="
                            $t(
                                'planning.form-planning-event.form-search-by-model-brand.select-version'
                            )
                        "
                        filled
                        :disabled="comboBoxes.version.disable"
                        :loading="comboBoxes.version.loading"
                    ></v-combobox>
                    <v-text-field
                        v-else
                        v-model="version"
                        :label="
                            $t(
                                'planning.form-planning-event.form-vehicle-manual-search.select-version'
                            )
                        "
                        filled
                        readonly
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row v-if="!readonly">
                <v-col class="d-flex justify-center" cols="12">
                    <v-btn
                        @click="() => searchInServices('final')"
                        rounded
                        class="btn-primary-custom text-capitalize"
                        :disabled="disableSearch"
                        >{{ $t("search") }}</v-btn
                    >
                </v-col>
            </v-row>
        </v-container>

        <base-modal
            v-model="modalAlertToLeave.show"
            :title="$t('heads-up')"
            modal-width="560px"
        >
            <template v-slot:modal-close>
                <div @click="() => closeModal(3)">
                    <img
                        src="/images/_SVGs/environmental/fechar.svg"
                        onload="SVGInject(this)"
                        width="20"
                        height="20"
                    />
                </div>
            </template>

            <template v-slot:modal-body>
                {{
                    $t(
                        "planning.form-planning-event.form-search-by-model-brand.modal-alert-leave-msg"
                    )
                }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn
                        text
                        class="danger-button"
                        @click="() => closeModal(2)"
                    >
                        <span style="text-transform: capitalize">{{
                            $t("no")
                        }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn
                        text
                        class="primary-button"
                        @click="() => closeModal(1)"
                    >
                        <span style="text-transform: capitalize">{{
                            $t("yes")
                        }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import mixinVehicleIdentification from "@mixins/b2b/vehicleIdentification";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {BaseModal},
    props: {
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        dialog: {
            type: Boolean,
            required: false,
            default: false,
        },
        redirectAfterSearch: {
            type: Boolean,
            required: false,
            default: true,
        },
        allowAutoSearch: {
            type: Boolean,
            required: false,
            default: false,
        },
        manualPlate: String,
        make: String,
        model: String,
        bodyGroup: String,
        fuelType: String,
        version: String,
        kType: String,
        hasVehicleOnStateForm: Boolean,
        default: false,
        byPlanning: false,
    },
    mixins: [mixinVehicleIdentification],
    watch: {
        comboBoxmakeValue(newValue, oldValue) {
            if (!this.readonly) {
                this.comboBoxmodelValue = "";
                this.comboBoxes.model = {
                    items: [],
                    disable: true,
                    loading: false,
                };
                if (newValue !== "" && newValue != null) {
                    this.searchInServices("model", newValue);
                }
            }
        },
        comboBoxmodelValue(newValue, oldValue) {
            if (!this.readonly) {
                this.comboBoxbodyworkValue = "";
                this.comboBoxes.bodywork = {
                    items: [],
                    disable: true,
                    loading: false,
                };
                if (newValue !== "" && newValue != null) {
                    this.searchInServices("bodywork", newValue);
                }
            }
        },
        comboBoxbodyworkValue(newValue, oldValue) {
            if (!this.readonly) {
                this.comboBoxfuelValue = "";
                this.comboBoxes.fuel = {
                    items: [],
                    disable: true,
                    loading: false,
                };
                if (newValue !== "" && newValue != null) {
                    this.searchInServices("fuel", newValue);
                }
            }
        },
        comboBoxfuelValue(newValue, oldValue) {
            if (!this.readonly) {
                this.comboBoxversionValue = "";
                this.comboBoxes.version = {
                    items: [],
                    disable: true,
                    loading: false,
                };

                if (newValue !== "" && newValue != null) {
                    this.searchInServices("version", newValue);
                }
            }
        },
        comboBoxversionValue(newValue, oldValue) {
            if (!this.readonly && this.allowAutoSearch && !this.disableSearch) {
                this.comboBoxes.make.disable = false;
                this.searchInServices("final");
            }
        },
        make: {
            handler: function (newValue, oldValue) {
                this.comboBoxBrandValue = newValue;
            },
            deep: true,
            immediate: true,
        },
        model: {
            handler: function (newValue, oldValue) {
                this.comboBoxModelValue = newValue;
            },
            deep: true,
            immediate: true,
        },
        bodyGroup: {
            handler: function (newValue, oldValue) {
                this.comboBoxBodyWorkValue = newValue;
            },
            deep: true,
            immediate: true,
        },
        fuelType: {
            handler: function (newValue, oldValue) {
                this.comboBoxFuelValue = newValue;
            },
            deep: true,
            immediate: true,
        },
        version: {
            handler: function (newValue, oldValue) {
                this.comboBoxVersionValue = newValue;
            },
            deep: true,
            immediate: true,
        },
        kType: {
            handler: function (newValue, oldValue) {
                this.kTypeValue = newValue;
            },
            deep: true,
            immediate: true,
        },
        manualPlate: {
            handler: function (newValue, oldValue) {
                if (newValue) {
                    this.manualPlateValue = String(newValue).toUpperCase();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        disableSearch() {
            return !(
                this.comboBoxversionValue &&
                this.comboBoxmakeValue &&
                this.comboBoxmodelValue &&
                this.comboBoxbodyworkValue &&
                this.comboBoxfuelValue
            );
        },
    },
    methods: {
        closeModal(save) {
            if (save == 1) {
                this.onSaveBudget();
            } else if (save == 2) {
                this.onDontSaveBudget();
            } else if (save == 3) {
                this.closeModalAlertToLeave(false);
            }
        },
    },
    mounted() {
        if (!this.readonly) {
            this.searchInServices("make");
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
.componente-search-by-model-make-planning {
    ::v-deep .header-title {
        flex-direction: column !important;

        h1,
        h2,
        p {
            color: $filinto-blue;
        }

        .description {
            text-align: justify;
        }
    }

    ::v-deep .title-class {
        color: $filinto-blue;
    }

    .container--fluid--override {
        padding-left: 0;
        padding-right: 0;

        .title {
            font-size: 18px;
            margin-bottom: 0px;
            color: $grey-dark;
        }

        .subtitle {
            font-size: 14px;
            color: $grey;
        }
    }

    h1 {
        font-size: 2.1em;
        line-height: 1.2em;
        font-weight: 400;
        color: #4b4849;
        margin-bottom: 30px;
    }

    h2 {
        font-size: 1.3em;
        line-height: 1.2em;
        font-weight: 400;
        color: #4b4849;
    }

    p {
        font-size: 1em;
    }

    .v-text-field__details {
        display: none;
    }
}

.v-card__title {
    word-break: break-word;
}
</style>
